import React from "react";
const InputWrapper = ({ children, className = void 0 }) => className ? /* @__PURE__ */ React.createElement("div", { className }, children) : /* @__PURE__ */ React.createElement("span", null, children);
export default InputWrapper;
